const config = {
  API_URL: process.env.REACT_APP_API_URL || "https://bunnybooksapp.com/api/v1",
  AUTOCOMPLETE_KEY: "AIzaSyD1AIfJmLKS2j3pYKJgkv0ypAlXcB1nm2A",
}

export default config
